import a from"./classof-raw.js";var s=a,o=Array.isArray||function(r){return s(r)=="Array"};export{o as default};
